/**
 * Created by Ning Jiang on 2022-10-29.
 */

export class WinCapClock {

    private _textField:PIXI.Text;
    private _hh:number;
    private _mm:number;
    private _ss:number;
    private _interval:any;

    constructor(textField:PIXI.Text) {
        this._textField = textField;
    }

    public start():void {
        this.stop();
        this.display();
        this._interval = setInterval(() => {
            this._ss++;
            if(this._ss >= 60) {
                this._ss -= 60;
                this._mm++;
            }
            if(this._mm >= 60) {
                this._mm -= 60;
                this._hh++;
            }
            this.display();
        }, 1000);
    }

    private display():void {
        const h = this._hh.toString();
        const m = this._mm > 9 ? this._mm.toString() : `0${this._mm.toString()}`;
        const s = this._ss > 9 ? this._ss.toString() : `0${this._ss.toString()}`;
        this._textField.text = `${h}:${m}:${s}`;
    }

    public stop():void {
        if(this._interval) {
            clearInterval(this._interval);
        }
        this._hh = this._mm = this._ss = 0;
    }
}